import { render, staticRenderFns } from "./funboxitem.vue?vue&type=template&id=46dee012&scoped=true&"
import script from "./funboxitem.vue?vue&type=script&lang=js&"
export * from "./funboxitem.vue?vue&type=script&lang=js&"
import style0 from "./funboxitem.vue?vue&type=style&index=0&id=46dee012&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dee012",
  null
  
)

export default component.exports